// Single source of truth for how we label model depth across the UI.
// soma v14 is an adaptive trace-branch mixer — depth is measured in residual swiglu blocks in the trunk / "layers".

export function depthValue(cp) {
  if (cp == null) return 1;
  return cp.depth || cp.n_stacks || cp.n_layers || 1;
}

export function depthNoun() {
  return 'layer';
}

export function depthLabel(cp) {
  const n = depthValue(cp);
  return `${n} layer${n === 1 ? '' : 's'}`;
}
